export default __webpack_public_path__ + "static/DynamoDB-fc665d2753c94744d5a5fe52faf83c3b.png";